import React from 'react';
import { Input } from '@/components/ui/input';

interface CurrencyInputProps {
  valueCents: number | null | undefined;
  onChange: (cents: number | null) => void;
  placeholder?: string;
}

export function CurrencyInput({ valueCents, onChange, placeholder = '$0' }: CurrencyInputProps) {
  const displayValue = valueCents != null ? (valueCents / 100).toLocaleString('en-US') : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    if (!raw) { onChange(null); return; }
    onChange(parseInt(raw) * 100);
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">$</span>
      <Input
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="pl-7"
      />
    </div>
  );
}
